<template>
  <div class="plv-ia-app plv-ia-card">
    <div class="">
      <CTable :columns="columns"  :data-list="dataList" tbody-height="400px">
        <template v-slot:cardImg="{ slotData }">
          <div class="plv-ia-card-table-preview-img">
            <img v-if="slotData.imageType === 'redpack'" src="./images/push-redpack.png" />
            <img v-else-if="slotData.imageType === 'giftbox'" src="./images/push-gift.png" />
            <img v-else-if="slotData.imageType === 'custom'" :src="slotData.cardImage" />
            <img v-else src="./images/push-redpack.png" />
            <p v-if="slotData.pushStatus === 'Y'" class="plv-ia-card-push__cover__tip plv-ia-card-push__cover__tip--pushing"> {{ t('plvIA.pushCard.pushing') }} </p>
            <p v-if="slotData.pushStatus === 'L'" class="plv-ia-card-push__cover__tip plv-ia-card-push__cover__tip--last"> {{ t('plvIA.pushCard.lastTime') }} </p>
          </div>
        </template>
        <template v-slot:handle="{ slotData }">
          <div>
            <span v-if="slotData.pushStatus === 'N' || slotData.pushStatus === 'L'" class="plv-ia-card-btn--push" @click="beforeSend(slotData)">{{ t('plvIA.pushCard.push')}}</span>
            <span v-else  class="plv-ia-card-btn--cancel" @click="stop(slotData)">{{ t('plvIA.pushCard.cancelPush')}}</span>
          </div>
        </template>
      </CTable>
    </div>

    <!-- 删除后将无法恢复，确认删除？ -->
    <PopupConfirm
      ref="plv-card-modal"
      :tips="t('plvIA.pushCard.confirmTips')"
      :ensure-txt="t('plvIA.common.confirm')"
      :cancel-txt="t('plvIA.common.cancel')"
      :ensure-btn-cls="'plv-ia-btn-new plv-ia-btn-orange-2'"
      @ensure="popupConfirm"
      @cancel="toggleDeleteCardModal(false)"
    />
  </div>
</template>

<script>
import CTable from '../../components/table/Table';
import CommonMixin from '../app-mixin';
import Locale from '@/mixins/locale';
import PopupConfirm from '@/components/popup/Confirm';
export default {
  name: 'PushCard',
  components: {
    CTable,
    PopupConfirm
  },
  mixins: [CommonMixin, Locale],
  props: {
    core: {
      type: Object,
      default: null
    }
  },
  watch: {
    lang: {
      handler() {
        this.initColumns();
      }
    },
  },
  data() {
    return {
      columns: [],
      dataList: [],
      isLoading: false,
      currentItem: null, // 当前需要推送的卡片
    };
  },
  methods: {
    afterCoreInited() {
      this.initColumns();
      this.getList();
      this.bindCoreListeners();
    },
    bindCoreListeners() {
      this.core.on('update-list', this.getList);
    },
    unbindCoreListeners() {
      this.core.off('update-list', this.getList);
    },
    beforeSend(item) {
      this.currentItem = item;
      let itemPushing = null;
      for (let i = 0; i < this.dataList.length; i++) {
        const item = this.dataList[i];
        if (item.pushStatus === 'Y') {
          itemPushing = item;
          break;
        }
      }
      if (itemPushing) {
        this.$refs['plv-card-modal'].show();
        return;
      }
      this.send(item);
    },
    async send(item) {
      try {
        await this.core.pushCard(item.id);
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
    },
    async popupConfirm() {
      await this.send(this.currentItem);
      this.toggleDeleteCardModal(false);
      await this.getList();
    },
    stop(item) {
      try {
        this.core.stopCard(item.id);
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
    },
    initColumns() {
      this.columns = [{
        label: this.t('plvIA.pushCard.pushCardStyle'),
        props: 'img',
        width: '100px',
        slotName: 'cardImg'
      }, {
        label: this.t('plvIA.pushCard.title'),
        props: 'title',
      }, {
        label: this.t('plvIA.pushCard.link'),
        props: 'link',
        width: '130px'
      }, {
        label: this.t('plvIA.pushCard.openType'),
        props: 'showConditionLabel',
        width: '120px'
      }, {
        label: this.t('plvIA.pushCard.cardEntry'),
        props: 'enterEnabledLabel',
        width: '80px'
      },
      {
        type: 'handle',
        label: this.t('plvIA.common.operation'),
        width: '100px'
      }
      ];
    },

    toggleDeleteCardModal(show) {
      show ? this.$refs['plv-card-modal'].show() : this.$refs['plv-card-modal'].hide();
    },
    async getList() {
      try {
        this.dataList = await this.core.getList();
        this.dataList.forEach(item => {
          const unit = item.conditionUnit === 'MINUTES' ? this.t('plvIA.pushCard.minutes') : this.t('plvIA.pushCard.seconds');
          item.showConditionLabel = item.showCondition === 'PUSH' ?
            this.t('plvIA.pushCard.pushImmediate') :
            this.t('plvIA.pushCard.pushDelay', { unit: unit, num: item.conditionValue });
          item.enterEnabledLabel = item.enterEnabled === 'Y' ? this.t('plvIA.pushCard.entryOpen') : this.t('plvIA.pushCard.entryClose');
        });
        // 接口根据创建时间升序排列，而后台的卡片列表通过翻转数组进行降序排列，这里保持跟后台同步。（该接口已经对外发布提供了，为不影响线上不改接口排序）
        this.dataList = this.dataList.reverse();
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
    }
  },
  beforeDestroy() {
    this.unbindCoreListeners();
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/main.scss';
.plv-ia-card {
  width: 100%;
  height: 500px;
  padding: 16px;
  box-sizing: border-box;
  .plv-ia-c-table-wrapper-table-tbody-tr {
    height: 100px;
    .plv-ia-c-table-wrapper-table-tbody-td {
      height: 100px !important;
      line-height: 100px !important;
      box-sizing: border-box;
    }
  }
  .plv-ia-confirm__body {
    padding: 0 12px;
  }
}
.plv-ia-card-table-preview-img {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    width: 68px;
    height: 68px;
  }
}
.plv-ia-card-btn--push {
  color: #2196F3;
  cursor: pointer;
}
.plv-ia-card-btn--cancel {
  color: #FF5722;
  cursor: pointer;
}
.plv-ia-card-push__cover__tip {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5px;
  width: 60px;
  height: 20px;
  line-height: 20px;
  border-radius: 11px;
  font-size: 12px;
  color: #2196f3;
  background: #d8e9f9;
  letter-spacing: 0;
  text-align: center;
  .plv-ia-card-push__cover__tip--pushing {
    color: #ff5722;
    background: #ffeae8;
  }
  .plv-ia-card-push__cover__tip--last {
    color: #2196f3;
    background: #d8e9f9;
  }
}

</style>
